module.exports = __webpack_public_path__ + "img/littleImg02.63746f7d.gif";